import { h, Component } from "preact";
import Ships from "./ships";

const uppercaseFilters = {
  all: "all",
  berthed: "BERTHED",
  expected: "EXPECTED",
  moving: "MOVING",
  raid: "RAID",
};

const validFilters = ["all", "raid", "berthed", "moving", "expected"];
const validSorts = ["none", "asc", "desc"];

export default class ShipsInPort extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isLoaded: false,
      shipFilter: "all",
      gtSort: "none",
      language: "",
    };
  }

  /**
   * Returns ship list API url
   *  
   * @returns {string} API url 
   */
  getShipLink = () => {
    return "https://oks.rop.lv/api/v1/getShipsForRop";
  };

  /**
   * Fetches ship data from API
   */
  getShipData = () => [
    fetch(this.getShipLink())
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            items: result,
          });
        },
        (error) => {
          console.log("kļūda");
        }
      ),
  ];

  /**
   * Changes the state of filter with selected value
   * 
   * @param {string} filter 
   */
  changeFilter = (filter) => {
    var url = new URL(location.href);
    history.pushState(
      url.origin,
      null,
      `/${this.state.language}/kugi-osta/${filter}${
        this.state.gtSort && this.state.gtSort !== "none"
          ? "/gt/" + this.state.gtSort
          : ""
      }`
    );
    this.setState({ shipFilter: filter });
  };

  /**
   * Changes GT sorting value
   */
  changeSort = () => {
    var sortValues = { // Rotates filter value to next value
      none: "desc",
      desc: "asc",
      asc: "none",
    };

    var url = new URL(location.href);

    history.pushState(
      url.origin,
      null,
      `/${this.state.language}/kugi-osta/${this.state.shipFilter}${
        sortValues[this.state.gtSort] &&
        sortValues[this.state.gtSort] !== "none"
          ? "/gt/" + sortValues[this.state.gtSort]
          : ""
      }`
    );

    this.setState({ gtSort: sortValues[this.state.gtSort] });
  };

  /**
   * Set language based on url value
   */
  setLanguageState = () => {
    if (window.location.href.includes("/lv")) {
      this.setState({ language: "lv" });
    } else if (window.location.href.includes("/ru")) {
      this.setState({ language: "ru" });
    } else if (window.location.href.includes("/en")) {
      this.setState({ language: "en" });
    }
  };

  /**
   * Sets initial filter and sort values based on url
   */
  setUrlFilters = () => {
    var url = window.location.pathname.split("/");

    var filter = url[3] ? url[3].toLowerCase() : null;
    var field = url[4] ? url[4].toLowerCase() : null;
    var direction = url[5] ? url[5].toLowerCase() : null;

    if (!filter || !validFilters.includes(filter)) {
      this.setState({ shipFilter: "all", gtSort: "none" });
      return;
    }

    if (!direction) {
      this.setState({ shipFilter: filter, gtSort: "none" });
      return;
    }

    if (!validSorts.includes(direction) || field !== "gt") {
      this.setState({ shipFilter: filter, gtSort: "none" });
      return;
    }

    this.setState({ shipFilter: filter, gtSort: direction });
    return;
  };

  componentDidMount() {
    this.setLanguageState();
    this.setUrlFilters();
    this.getShipData();
  }

  render() {
    if (this.state.isLoaded && this.state.items) {
      return (
        <>
          <div class="ships-filter-div"> {/* Div containing all filter buttons */}
            <button
              class={this.state.shipFilter === "all" ? " active" : ""}
              onclick={() => this.changeFilter("all")}
            >
              {this.state.language === "lv"
                ? "VISI"
                : this.state.language === "en"
                ? "ALL"
                : "ВСЕ"}
            </button>
            <button
              class={this.state.shipFilter === "berthed" ? " active" : ""}
              onclick={() => this.changeFilter("berthed")}
            >
              {this.state.language === "lv"
                ? "OSTĀ"
                : this.state.language === "en"
                ? "IN PORT"
                : "В ПОРТУ"}
            </button>
            <button
              class={this.state.shipFilter === "expected" ? " active" : ""}
              onclick={() => this.changeFilter("expected")}
            >
              {this.state.language === "lv"
                ? "PLĀNOTS"
                : this.state.language === "en"
                ? "EXPECTED"
                : "ОЖИДАЕТСЯ"}
            </button>
            <button
              class={this.state.shipFilter === "moving" ? " active" : ""}
              onclick={() => this.changeFilter("moving")}
            >
              {this.state.language === "lv"
                ? "KUSTĪBĀ"
                : this.state.language === "en"
                ? "MOVING"
                : "В ДВИЖЕНИЕ"}
            </button>
            <button
              class={this.state.shipFilter === "raid" ? " active" : ""}
              onclick={() => this.changeFilter("raid")}
            >
              {this.state.language === "lv"
                ? "REIDĀ"
                : this.state.language === "en"
                ? "RAID"
                : "НА РЕЙДЕ"}
            </button>
            <button
              class={
                "gt-sort-button " +
                (this.state.gtSort !== "none" ? "active" : "none")
              }
              onclick={() => this.changeSort()}
            >
              GT
              <img
                class={"ships-sort-arrow " + this.state.gtSort}
                src="/img/sort_arrow.png"
              />
            </button>
          </div>

          {/* Ship list component rendering */}    
          <Ships
            shipFilter={uppercaseFilters[this.state.shipFilter]}
            gtSort={this.state.gtSort}
            language={this.state.language}
            items={this.state.items}
          />
        </>
      );
    } else {
      return null;
    }
  }
}
